import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetAgendamiento } from '@/shared/actions/erp';
import { SaveRecoordinacionPyL } from '../../shared/components/forms';

export type AgendaRecoordinacionPyLPageProps = {};

const AgendaRecoordinacionPyLPage: React.FC<
  AgendaRecoordinacionPyLPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_agendamiento);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useGetAgendamiento(id!);
  useLoaders(isLoading || isRefetching);

  if (isLoading ) return null;
  if (!data?.data?.id_agendamiento)
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SaveRecoordinacionPyL
      title="Recoordinación de Agendamiento Obsoleto"
      agendamiento={data.data}
    />
  );
};

export default AgendaRecoordinacionPyLPage;
